import { render, staticRenderFns } from "./EditPoint.vue?vue&type=template&id=5f3bd444&"
import script from "./EditPoint.vue?vue&type=script&lang=js&"
export * from "./EditPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports